import React, { useState } from 'react';
import { motion } from 'framer-motion';
import FlipCard from './FlipCard';
import { LEARNING_DATA } from '../data/learningData';

export default function DataMines({ onExitMine }) {
  const [category, setCategory] = useState('SQL');
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [sessionEarnings, setSessionEarnings] = useState(0);

  const currentDeck = LEARNING_DATA[category] || [];
  const currentCard = currentDeck.length > 0 
    ? currentDeck[currentCardIndex % currentDeck.length] 
    : { term: "Loading", definition: "No Data" };

  const handleCardClick = () => {
    if (!isFlipped) setIsFlipped(true);
  };

  const handleNextCard = () => {
    setSessionEarnings(prev => prev + 100);
    setIsFlipped(false);
    setTimeout(() => {
      setCurrentCardIndex(prev => prev + 1);
    }, 200);
  };

  const handleCashOut = () => {
    onExitMine(sessionEarnings);
  };

  return (
    <div className="fixed inset-0 bg-slate-950 z-50 flex flex-col items-center justify-center p-4">
      
      <div className="text-center mb-8 w-full max-w-lg">
        <h1 className="text-4xl font-bold text-yellow-500 mb-2">The Data Mines</h1>
        <p className="text-slate-400">You are bankrupt! Study to earn your salary back.</p>
        
        <div className="flex gap-2 justify-center mt-4 flex-wrap">
          {Object.keys(LEARNING_DATA).map(cat => (
            <button
              key={cat}
              onClick={() => { setCategory(cat); setCurrentCardIndex(0); setIsFlipped(false); }}
              className={`px-3 py-1 rounded text-sm ${category === cat ? 'bg-cyan-600 text-white' : 'bg-slate-800 text-slate-400'}`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* --- LAYOUT FIX --- */}
      <div className="mb-8 w-full flex justify-center perspective-container">
        <FlipCard 
          data={currentCard} 
          isFlipped={isFlipped} 
          onClick={handleCardClick} 
        />
      </div>

      <div className="flex flex-col items-center gap-4 w-full max-w-sm">
        {isFlipped ? (
          <motion.button
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            onClick={handleNextCard}
            className="w-full bg-green-500 hover:bg-green-600 text-black font-bold py-3 rounded-lg shadow-lg flex justify-between px-6"
          >
            <span>I Learned This</span>
            <span>+ $100</span>
          </motion.button>
        ) : (
          <div className="h-12 flex items-center text-slate-500 italic">
            (Tap card to reveal definition)
          </div>
        )}

        <div className="w-full bg-slate-900 border border-slate-700 p-4 rounded-lg flex justify-between items-center">
          <div>
            <div className="text-xs text-slate-500 uppercase">Current Session</div>
            <div className="text-2xl text-yellow-400 font-mono">${sessionEarnings}</div>
          </div>
          <button 
            onClick={handleCashOut}
            disabled={sessionEarnings === 0}
            className={`px-4 py-2 rounded font-bold transition-all ${
              sessionEarnings > 0 
              ? 'bg-white text-slate-900 hover:bg-slate-200' 
              : 'bg-slate-700 text-slate-500 cursor-not-allowed'
            }`}
          >
            Cash Out
          </button>
        </div>
      </div>
    </div>
  );
}